<template>
  <div id="app">
    <header id="header" v-if="$route.name != 'meet'">
      <nav class="navbar m-0 p-0">
        <div class="menu-bar">
          <b-icon icon="list" font-scale="2"></b-icon>
        </div>

        <a class="navbar-brand d-flex align-items-center w-25 m-0" href="/app/dashboard">
          <img alt="BhioTrack Logo" class="d-inline-block" src="@/assets/images/logo.png" />
          <p class="text-muted m-0">{{ getRouteTitle }}</p>
        </a>
        <form class="form-inline w-25">
          <b-input-group class="m-0 p-0 w-100">
            <b-input-group-prepend>
              <b-button variant="outline-secondary" @click="handleSearch">
                <b-icon style="margin-bottom: 2px" font-scale="0.95" icon="search"></b-icon
              ></b-button>
            </b-input-group-prepend>

            <b-form-input
              placeholder="Pesquisar por nome ou CPF"
              id="input-search"
              v-model="searchInput"
              @keydown.enter.prevent="handleSearch"
            ></b-form-input>
          </b-input-group>
        </form>

        <form class="form-inline w-25 justify-content-end">
          <b-dropdown class="p-0">
            <template #button-content>
              <div class="filled-rounded">
                {{ userInitials }}
              </div>
            </template>

            <b-dropdown-item href="#" @click.prevent="logout()">Sair</b-dropdown-item>
          </b-dropdown>
        </form>
      </nav>
    </header>

    <!-- Sidebar para navegação -->
    <aside id="sidebar" v-if="$route.name !== 'login' && $route.name !== 'meet'">
      <nav class="navbar m-0 p-0">
        <ul class="navbar-nav">
          <li class="nav-item" v-if="!isPA">
            <router-link
              class="nav-link rounded-circle"
              to="/app/schedule-day"
              v-b-tooltip.hover.left="{
                customClass: 'tooltip',
              }"
              title="Minha agenda"
            >
              <img :src="$route.name == 'schedule-day' ? calendarIcon : calendarIconDisable" alt="" />
            </router-link>
          </li>

          <li class="nav-item" v-if="!isPA">
            <router-link
              class="nav-link rounded-circle"
              to="/app/overbook-queue"
              v-b-tooltip.hover.left="{
                customClass: 'tooltip',
              }"
              title="Sala de espera (Pessoal)"
            >
              <img :src="$route.name == 'dashboard' ? dashboardIcon : dashboardIconDisable" alt="" />
            </router-link>
          </li>

          <li class="nav-item" v-if="!isElective">
            <router-link
              class="nav-link rounded-circle"
              to="/app/dashboard"
              v-b-tooltip.hover.left="{
                customClass: 'tooltip',
              }"
              title="Fila de atendimento"
            >
              <img :src="$route.name == 'dashboard' ? dashboardIcon : dashboardIconDisable" alt="" />
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              class="nav-link rounded-circle"
              to="/app/patients-list"
              v-b-tooltip.hover.left="{
                customClass: 'tooltip',
              }"
              title="Lista de pacientes"
            >
              <img :src="$route.name == 'patients-list' ? historyIcon : historyIconDisable" alt="" />
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              class="nav-link rounded-circle"
              to="/app/schedule-report"
              v-b-tooltip.hover.left="{
                customClass: 'tooltip',
              }"
              title="Exportar relatório"
            >
              <img :src="$route.name == 'schedule-report' ? reportIcon : reportIconDisable" alt="" />
            </router-link>
          </li>
        </ul>
      </nav>
    </aside>

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <loader-layout
      v-show="
        userStatus === 'pending' ||
        (queueStatus === 'pending' && $route.name === 'dashboard') ||
        meetStatus === 'pending' ||
        searchPatientsStatus === 'pending' ||
        (schedulesPageStatus === 'pending' && $route.name === 'schedule-day') ||
        pullOverbookStatus === 'pending' ||
        pullQueueStatus === 'pending'
      "
    />
    <!-- <no-internet-modal /> -->
  </div>
</template>

<script>
import calendarIconDisable from '@/assets/images/icons-sidebar/calendar/disable.svg';
import calendarIcon from '@/assets/images/icons-sidebar/calendar/enable.svg';
import historyIconDisable from '@/assets/images/icons-sidebar/history/disable.svg';
import historyIcon from '@/assets/images/icons-sidebar/history/enable.svg';
import dashboardIconDisable from '@/assets/images/icons-sidebar/line/disable.svg';
import dashboardIcon from '@/assets/images/icons-sidebar/line/enable.svg';
import reportIconDisable from '@/assets/images/icons-sidebar/report/disable.svg';
import reportIcon from '@/assets/images/icons-sidebar/report/enable.svg';
import { mapActions, mapGetters } from 'vuex';
import LoaderLayout from './LoaderLayout.vue';
export default {
  name: 'steps-layout',
  data() {
    return {
      searchInput: '',
      calendarIcon,
      calendarIconDisable,
      dashboardIcon,
      dashboardIconDisable,
      historyIcon,
      historyIconDisable,
      reportIcon,
      reportIconDisable,
      title: '',
    };
  },
  computed: {
    ...mapGetters({
      userStatus: 'users/getUserResquestStatus',
      queueStatus: 'schedule/getQueueResquestStatus',
      pullQueueStatus: 'schedule/getPullQueueStatus',
      schedulesPageStatus: 'schedule/getSchedulesStatus',
      meetStatus: 'consultation/getRequestStatus',
      queue: 'schedule/getQueueList',
      getUserStorage: 'users/getUserFromStorage',
      getCids: 'consultation/getCIDs',
      searchPatientsStatus: 'schedule/getSearchPatientsStatus',
      pullOverbookStatus: 'schedule/getPullOverbookStatus',
    }),
    userInitials() {
      let item = localStorage.getItem('user');
      if (item == 'undefined' || !item) return 'OO';
      item = JSON.parse(item);
      let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
      let initials = [...item.name.matchAll(rgx)] || [];
      initials = ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase();
      return initials;
    },
    isElective() {
      return this.getUserStorage.serviceType === 'Eletivo';
    },
    isPA() {
      return this.getUserStorage.serviceType?.toLowerCase() === 'pa';
    },
    getRouteTitle() {
      switch (this.$route.name) {
        case 'schedule-day':
          return 'Agenda';
        case 'dashboard':
          return 'Atendimento';
        case 'search':
          return 'Pesquisa';
        case 'patient-details':
          return 'Paciente';
        case 'patients-list':
          return 'Pacientes';
        case 'schedule-report':
          return 'Relatório';
        default:
          return '';
      }
    },
  },
  methods: {
    ...mapActions({
      clearProfile: 'users/doLogout',
      setInputSearch: 'schedule/setInputSearch',
      searchPatients: 'schedule/searchPatients',
      queueList: 'schedule/queueList',
      listOfCIDs: 'consultation/listOfCIDs',
      fetchMeetInProgress: 'schedule/meetInProgress',
    }),

    logout() {
      this.clearProfile();
      window.location.href = '/login';
    },
    async handleSearch() {
      let param = {
        type: this.getInputType(),
        value: this.setCpfFormated(this.searchInput),
        limit: 12,
      };
      try {
        await this.searchPatients(param);
        this.setInputSearch({ ...param });
        clearInterval();
        if (this.$route.name != 'search') this.$router.push({ name: 'search' });
        this.setNotification('success', 'Pesquisa feita com sucesso!');
      } catch (error) {
        this.setNotification('error', 'Erro ao buscar paciente');
      }
    },
    getInputType() {
      let rgx = new RegExp(/^[0-9]+$/);
      let type = rgx.test(this.searchInput.replace(/[^0-9a-zA-Z]/g, '')) ? 'cpf' : 'name';
      return type;
    },
    setCpfFormated(input) {
      let formated = input;
      if (this.getInputType() == 'cpf') formated = formated.replace(/[^0-9]/g, '');
      return formated;
    },
    setNotification(type, message) {
      this.$notify({
        text: message,
        type: type,
        duration: 10000,
        speed: 1000,
      });
    },
    setTitle() {},
    async fetchQueueList() {
      try {
        await this.queueList();
        const title = 'Agenda Pro - BhioTrack';
        document.title = `(${this.queue.length || 0}) ${title}`;
      } catch (error) {
        this.setNotification('error', error?.response?.data?.message || 'Erro ao buscar a fila de atendimento');
      }
    },
  },
  mounted() {
    const CIDS = this.getCids;
    if (!CIDS) this.listOfCIDs();

    if (!this.isElective) {
      this.fetchQueueList();
      setInterval(() => {
        this.fetchQueueList();
      }, 30000);
    }
    this.fetchMeetInProgress();
    setInterval(() => {
      this.fetchMeetInProgress();
    }, 30000);
  },

  components: { LoaderLayout },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables';

#app {
  display: flex;
  height: 100%;
  flex-direction: column;
}

header#header {
  background: #fff;
  padding: 1.2rem 1.5rem;
  border-bottom: 1px solid $ipt-border;
  position: fixed;
  width: 100%;
  height: 85px;
  z-index: 10;
  // position: relative;
  nav {
    a:not(.dropdown-item) {
      gap: 16px;
      font-weight: 400;
      font-size: 16px;
      letter-spacing: -0.02em;
      margin-left: 85px !important;
      padding: 0 !important;
      img {
        height: 44px;
      }
    }
    .menu-bar {
      position: fixed;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid $ipt-border;
      top: 0;
      left: 0;
      height: 85px;
      width: 81px;
      color: $btn-pri-bg;
    }
  }
  // &::before {
  // 	content: " ";
  // 	width: 10vw;
  // 	height: 4px;
  // 	background: $btn-pri-bg;
  // 	position: absolute;
  // 	bottom: -4px;
  // 	left: -5px;
  // 	border-radius: 15px;
  // }
  .filled-rounded {
    width: 40px;
    height: 40px;
    background-color: #edefff;
    color: #1e2864;
    border-radius: 100%;
    text-align: center;
    margin: 0;
    padding: 0.5rem 0rem;
  }
  .navbar {
    .btn-group {
      .btn {
        background: transparent !important;
        border: none;
      }
      .dropdown-toggle {
        padding: 0;
        &::after {
          display: none !important;
        }
      }
    }

    .form-inline {
      .input-group {
        .form-control {
          border-left: 0 !important;
          height: calc(1.5em + 0.75rem + 5px);
        }
        #input-search {
          font-weight: 400;
          font-size: 14px;
        }
        .input-group-prepend {
          border-right: 0 !important;
          .btn {
            border: 1px solid #ced4da;
            border-right: 0 !important;
          }
        }
      }
    }
  }
}

#sidebar {
  position: fixed;
  left: 0;
  top: 85px;
  background: #ffffff;
  border-right: 1px solid #e5e6ec;
  padding: 32px 16px;
  height: 100%;
  z-index: 99;
  ul {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    .nav-link {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px;
      width: 48px;
      height: 48px;
      transition: 0.4s;

      &:hover {
        background: $btn-sec-bg;
      }

      &.router-link-active {
        background: $btn-sec-bg;
      }
    }
  }
}
</style>
